import React, { useState } from 'react';
import MobileTicketCard from './components/MobileTicketCard';
import TicketDetailsModal from '../../../../../../components/modals/ticketDetailsModal/TicketDetailsModal';

function MobileTicketsList({
  purchases = {},
  title = '',
  handleDownloadTicket,
  handleAdditionalServices,
  handleTicketRefund,
  expired = false,
}) {
  const [detailsModal, setDetailsModal] = useState({
    show: false,
    data: [],
  });

  const handleShowDetails = (data) => {
    setDetailsModal({
      show: true,
      data,
    });
  };
  return (
    <div className="flex flex-col gap-3">
      <h2>{title.toUpperCase()}</h2>
      {Object.values(purchases).map((purchase) => (
        <MobileTicketCard
          key={purchase[0].id}
          purchase={purchase}
          handleDownloadTicket={() => handleDownloadTicket(purchase)}
          handleShowDetails={() => handleShowDetails(purchase)}
        />
      ))}
      <TicketDetailsModal
        expired={expired}
        handleAdditionalServices={handleAdditionalServices}
        detailsModal={detailsModal}
        handleTicketRefund={handleTicketRefund}
        setDetailsModal={setDetailsModal}
      />
    </div>
  );
}

export default MobileTicketsList;
